import React, { useState } from "react";
import { createPortal } from "react-dom";

export default function AdBanner({ ad, layout = "card" }) {
  const [hover, setHover] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  if (!ad) return null;

  const websiteHref = ad.website
    ? (ad.website.startsWith("http") ? ad.website : `https://${ad.website}`)
    : null;

  if (layout === "banner") {
    return (
      <>
        <div
          style={{...s.bannerCard, ...(hover ? s.bannerCardHover : {})}}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => setShowDetail(true)}
        >
          {ad.image_url ? (
            <img src={ad.image_url} alt={ad.business_name} style={s.bannerImage} />
          ) : (
            <div style={s.bannerPlaceholder}>📢</div>
          )}
          <div style={s.bannerContent}>
            <span style={s.bannerBadge}>PUBLICIDAD</span>
            <h3 style={s.bannerTitle}>{ad.business_name}</h3>
          </div>
          <span style={s.bannerArrow}>›</span>
        </div>

        {showDetail && createPortal(
          <div style={s.overlay} onClick={() => setShowDetail(false)}>
            <div style={s.detailModal} onClick={e => e.stopPropagation()}>
              <button style={s.closeBtn} onClick={() => setShowDetail(false)}>✕</button>

              {ad.image_url ? (
                <img src={ad.image_url} alt={ad.business_name} style={s.detailImage} />
              ) : (
                <div style={s.detailPlaceholder}><span>Publicidad</span></div>
              )}

              <div style={s.detailContent}>
                <span style={s.detailBadge}>PUBLICIDAD</span>
                <h3 style={s.detailTitle}>{ad.business_name}</h3>
                <p style={s.detailDescription}>{ad.description}</p>

                {websiteHref && (
                  <a href={websiteHref} target="_blank" rel="noreferrer" style={s.button}>
                    Ver más
                  </a>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
      </>
    );
  }

  return (
    <>
      <div
        style={{...s.card, ...(hover ? s.cardHover : {})}}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => setShowDetail(true)}
      >
        <div style={s.imageWrapper}>
          {ad.image_url ? (
            <img src={ad.image_url} alt={ad.business_name} style={s.image} />
          ) : (
            <div style={s.placeholder}><span>Publicidad</span></div>
          )}
          <div style={s.badge}>PUBLICIDAD</div>
        </div>

        <div style={s.content}>
          <h3 style={s.title}>{ad.business_name}</h3>
        </div>
      </div>

      {showDetail && createPortal(
        <div style={s.overlay} onClick={() => setShowDetail(false)}>
          <div style={s.detailModal} onClick={e => e.stopPropagation()}>
            <button style={s.closeBtn} onClick={() => setShowDetail(false)}>✕</button>

            {ad.image_url ? (
              <img src={ad.image_url} alt={ad.business_name} style={s.detailImage} />
            ) : (
              <div style={s.detailPlaceholder}><span>Publicidad</span></div>
            )}

            <div style={s.detailContent}>
              <span style={s.detailBadge}>PUBLICIDAD</span>
              <h3 style={s.detailTitle}>{ad.business_name}</h3>
              <p style={s.detailDescription}>{ad.description}</p>

              {websiteHref && (
                <a href={websiteHref} target="_blank" rel="noreferrer" style={s.button}>
                  Ver más
                </a>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

const s = {
  card: {
    background: "#fff",
    borderRadius: 20,
    overflow: "hidden",
    border: "1px solid #e9e9e9",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
    cursor: "pointer",
  },

  cardHover: {
    transform: "scale(1.03)",
    boxShadow: "0 10px 28px rgba(29,158,117,0.18)",
    borderColor: "#1D9E75",
  },

  // ── Layout banner horizontal (mobile, intercalado en el catalogo) ────────
  bannerCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 12,
    background: "#fff",
    borderRadius: 16,
    border: "1px solid #e9e9e9",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    padding: 10,
    boxSizing: "border-box",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
  },
  bannerCardHover: {
    transform: "scale(1.015)",
    boxShadow: "0 8px 22px rgba(29,158,117,0.18)",
    borderColor: "#1D9E75",
  },
  bannerImage: {
    width: 92, height: 92, borderRadius: 12, objectFit: "cover",
    flexShrink: 0, background: "#f5f5f5",
  },
  bannerPlaceholder: {
    width: 92, height: 92, borderRadius: 12, flexShrink: 0,
    background: "#f1f1f1", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 30,
  },
  bannerContent: { flex: 1, minWidth: 0 },
  bannerBadge: {
    display: "inline-block", background: "#f0faf6", color: "#1D9E75",
    padding: "2px 8px", borderRadius: 999, fontSize: 9, fontWeight: 700, marginBottom: 4,
  },
  bannerTitle: {
    fontSize: 15, fontWeight: 700, color: "#111", margin: 0,
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
  },
  bannerArrow: { fontSize: 22, color: "#ccc", flexShrink: 0, paddingRight: 4 },

  imageWrapper: { position: "relative" },

  image: {
    width: "100%",
    aspectRatio: "1/ 1",
    objectFit: "cover",
    display: "block",
    background: "#f5f5f5",
  },

  placeholder: {
    width: "100%",
    aspectRatio: "1 / 1",
    background: "#f1f1f1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    fontSize: 14,
    fontWeight: 600,
  },

  badge: {
    position: "absolute",
    top: 12,
    left: 12,
    background: "rgba(0,0,0,0.7)",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: 999,
    fontSize: 10,
    fontWeight: 700,
  },

  content: { padding: 14 },

  title: {
    fontSize: 15,
    fontWeight: 700,
    color: "#111",
    margin: 0,
    textAlign: "center",
  },

  // ── Modal de detalle ──────────────────────────────────────────────────────
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 300, padding: 20,
  },
  detailModal: {
    background: "#fff", borderRadius: 20, width: "100%", maxWidth: 420,
    maxHeight: "90vh", overflowY: "auto", position: "relative",
  },
  closeBtn: {
    position: "absolute", top: 12, right: 12, zIndex: 2,
    width: 32, height: 32, borderRadius: "50%", border: "none",
    background: "rgba(0,0,0,0.55)", color: "#fff", fontSize: 15, cursor: "pointer",
  },
  detailImage: { width: "100%", aspectRatio: "1/1", objectFit: "cover", display: "block", background: "#f5f5f5" },
  detailPlaceholder: {
    width: "100%", aspectRatio: "1/1", background: "#f1f1f1",
    display: "flex", alignItems: "center", justifyContent: "center", color: "#999", fontWeight: 600,
  },
  detailContent: { padding: 20 },
  detailBadge: {
    display: "inline-block", background: "#111", color: "#fff", padding: "4px 10px",
    borderRadius: 999, fontSize: 10, fontWeight: 700, marginBottom: 10,
  },
  detailTitle: { fontSize: 20, fontWeight: 700, color: "#111", margin: 0, marginBottom: 10 },
  detailDescription: { fontSize: 14, color: "#666", lineHeight: 1.6, marginBottom: 18 },

  button: {
    width: "100%",
    height: 44,
    borderRadius: 12,
    background: "#1D9E75",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: 14,
  },
};
